import { Component, AfterViewInit, ApplicationRef, OnDestroy } from '@angular/core';

declare var $: any;

@Component({
  selector: 'lz-message-component',
  template: `<div class="lz-message" [ngClass]="{'lz-message-hide': !isShow}">
  <span>{{componentData.text}}</span>
  <div class="close" (click)="close()">
    <i class="fa fa-times"></i>
  </div>
</div>
`,
  styles: [`.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}:host .lz-message{font-family:Geometria,Arial,sans-serif;position:fixed;bottom:20px;left:20px;background-color:rgba(0,0,0,.65);color:#fff;padding:10px 35px 10px 10px;border-radius:5px;z-index:1112}:host .lz-message .close{position:absolute;right:13px;top:50%;font-size:16px;line-height:20px;margin-top:-10px;cursor:pointer}:host .lz-message.lz-message-hide{display:none}`]
})

export class MessageComponent implements AfterViewInit, OnDestroy {

  public isShow = true;
  public componentData: any;

  constructor(private appRef: ApplicationRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.close();
    }, 5000);
  }

  close = () => {
    if (this.componentData && this.componentData.componentRef) {
      this.appRef.detachView(this.componentData.componentRef.hostView);
      this.componentData.componentRef.destroy();
    }
  }

  //After state change (that occurs on 404 error)
  //component does not disappear from DOM and View after it was destroyed,
  //so it need to totally remove it
  ngOnDestroy() {
    try {
      setTimeout(() => {
        let removedComponent = $('lz-message-component');
        if (removedComponent.length !== 0) {
          removedComponent.remove();
        }
      }, 1500);
    } catch (error) {} finally {}
  }

}
